import { Controller } from "@hotwired/stimulus"
import { jquery } from 'utils/jquery'

export default class extends Controller {

  refresh(event) {
    let [_data, _status, xhr] = event.detail;
    // Browser-QA hardening (importation-overview follow-up) — this handler is wired
    // unconditionally (ImportationOverviewComponent's outer div always carries this
    // controller's identifier, and the filter form's `ajax:success` action always targets it,
    // regardless of `validation_grid_enabled?`), but `.voter_list_table_component` only ever
    // renders in LEGACY (flag-off) mode — in grid mode this target simply doesn't exist. Without
    // this guard, a stray/legacy ajax:success (e.g. from any residual submission path this
    // component's own interceptSubmit didn't anticipate) would throw
    // `TypeError: Cannot set properties of null (setting 'innerHTML')` instead of safely no-oping.
    let target = document.querySelector('.voter_list_table_component');
    if (!target) return;

    target.innerHTML = xhr.response;
  }

  update(event) {
    EB.Elections.VoterListController.disableAdminProceedToReview('validate_voter_list_message')
    let voterAttributeValue = event.target.getAttribute('data-voter-attribute-value');
    let voterAttributeUpdatedValue =  event.target.innerText;
    if (voterAttributeValue == voterAttributeUpdatedValue) {
      event.preventDefault();
      return;
    }

    let voterParams = JSON.parse(event.target.getAttribute('data-voter-params'));
    let voterAttributeName = event.target.getAttribute('data-voter-attribute-name');
    voterParams[voterAttributeName] = voterAttributeUpdatedValue;
    let voterId = voterParams['id'];

    const $ = jquery();
    if (!$) {
      return;
    }

    $.ajax({
      url: `voter_information_lines/${voterId}`,
      type: 'PATCH',
      dataType: 'SCRIPT',
      data: voterParams
    });
  }
}
